export default __webpack_public_path__ + "static/media/wave.3db9d0b1.svg";